import React, { useState, useEffect } from "react";
import { Button, Col, ListGroup, Modal, Row, Table } from "react-bootstrap";
import { Alert, DatePicker, Input } from "antd";
import Loader from "../../../../components/Loader";
import Message from "../../../../components/Message";
import { useSelector } from "react-redux";
import { calculateMaidStats } from "../../../../controllers/reports";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboard, faXmark } from "@fortawesome/free-solid-svg-icons";
import {
  faMagnifyingGlass,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import * as XLSX from "xlsx";
import usePermissions from "../../../../hook/userPermission";
const { RangePicker } = DatePicker;

const AirbnbSumarized = ({ toDownload, isAdmin, maids, type }) => {
  const { hasPermission } = usePermissions();
  const [dateRange, setDateRange] = useState([null, null]);
  const [unitName, setUnitName] = useState("");
  const [filteredMaidListData, setFilteredMaidListData] = useState([]);
  const [noResults, setNoResults] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedMaid, setSelectedMaid] = useState(null);
  const options = { year: "numeric", month: "numeric", day: "numeric" };

  const maidEarnings = useSelector((state) => state.maidEarnings);
  const {
    loading: filterdLoading,
    earnings,
    error: filteredError,
  } = maidEarnings;

  const requiredMaidEarnings = earnings.filter((maid) => maid.type == type);

  const handleDateRangeChange = (dates) => {
    setDateRange(dates || [null, null]);
    if (!dates || !dates[0] || !dates[1]) {
      maids.forEach((maid) => {
        maid.totalTipsInRange = null;
      });
    }
  };
  // const disabledDate = (current) => {
  //   const [start] = dateRange || [];
  //   // Disable dates before the start date when selecting end date
  //   if (start) {
  //     return current && current < start.startOf("day");
  //   }
  //   return false;
  // };
  const handleUnitNameFilter = (e) => {
    setUnitName(e.target.value);
  };
  const handleFilter = () => {
    const filteredList = maids
      .map((maid) => {
        const maidCopy = { ...maid }; // avoid mutating original
        // Filter by unit name
        if (
          unitName &&
          !maidCopy.unitName?.toLowerCase().includes(unitName.toLowerCase())
        ) {
          return null;
        }
        // Filter by date range
        if (dateRange && dateRange[0] && dateRange[1]) {
          const startTime = new Date(dateRange[0]).setHours(0, 0, 0, 0);
          const endTime = new Date(dateRange[1]).setHours(23, 59, 59, 999);

          const tipsInRange = maidCopy.tips.filter((tip) => {
            const tipTime = new Date(tip.date).getTime();
            return tipTime >= startTime && tipTime <= endTime;
          });

          if (tipsInRange.length === 0) {
            return null;
          }
          maidCopy.totalTipsInRange = tipsInRange.reduce(
            (total, tip) => total + tip.amount,
            0
          );
          maidCopy.totalReviewsInRange = tipsInRange.length;
        }

        return maidCopy;
      })
      .filter(Boolean); // remove nulls

    setFilteredMaidListData(filteredList);
    setNoResults(filteredList.length === 0);
  };

  const handleDownloadExcel = () => {
    const dataToExport =
      filteredMaidListData.length > 0 &&
      (unitName || (dateRange && dateRange[0] && dateRange[1]))
        ? filteredMaidListData
        : maids;

    const data = dataToExport.map((maid) => ({
      Address: maid.unitAddress,
      "Unit Name": maid.unitName,
      "Total Earnings":
        maid.totalTipsInRange || calculateMaidStats(maid).totalEarnings,
      "Total Reviews":
        maid.totalReviewsInRange || calculateMaidStats(maid).totalReviews,
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Summarized Reports");

    XLSX.writeFile(workbook, "summarized-reports.xlsx");
  };

  const handleModal = (maid) => {
    setSelectedMaid(maid);
    setShowModal(!showModal);
  };
  return (
    <>
      {/* ------------------------------------------------- MAID REPORT MODAL ------------------------------------------------- */}
      <Modal
        backdrop="static"
        centered
        show={showModal}
        onHide={handleModal}
        size="xl"
      >
        <Modal.Header className="bg-primary text-light">
          <Row className="w-100">
            <Col md="auto" className="ms-auto p-0">
              <Button
                variant="outline-light p-0 px-1  m-0 border-0"
                onClick={() => setShowModal(false)}
              >
                <FontAwesomeIcon className="fs-4" icon={faXmark} />
              </Button>
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body className="report">
          {selectedMaid && (
            <>
              <h5>{selectedMaid.unitName}'s Earning</h5>
              {/* {startDate != "" && endDate != "" ? (
                <>
                  <span className="text-muted">From</span>
                  <span className="text-success mx-2">{startDate}</span>
                  <span className="text-muted">to</span>
                  <span className="text-success mx-2">{endDate}</span>
                </>
              ) : (
                <></>
              )} */}
              <ListGroup
                variant="flush"
                className=" p-3 my-3 rounded-1 border border-1"
              >
                <ListGroup.Item className="">
                  <Row className="justify-content-evenly">
                    <Col md={2} className="text-success">
                      Date
                    </Col>
                    <Col md={4} className="text-success">
                      Transaction Id
                    </Col>
                    <Col md={1} className="text-success">
                      Tip
                    </Col>
                    <Col md={2} className="text-success">
                      Reviews
                    </Col>
                    <hr className="mb-0 mt-1 p-0" />
                  </Row>
                </ListGroup.Item>
                {selectedMaid.tips.map((tip, index) => (
                  <ListGroup.Item className="py-0 my-2" key={index}>
                    <Row className="justify-content-evenly">
                      <Col md={2}>
                        {new Date(tip.date).toLocaleDateString(
                          "en-US",
                          options
                        )}
                      </Col>
                      <Col md={4} className="text-muted px-0">
                        {tip.paymentId}
                      </Col>
                      <Col md={1}>${tip.amount}</Col>

                      <Col md={2}>{tip.review}</Col>
                    </Row>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </>
          )}
        </Modal.Body>
        {/* <Modal.Footer>
          {isAdmin || toDownload ? (
            <>
              <Button
                onClick={() => handleDownload(selectedMaid)}
                variant="success"
              >
                <FontAwesomeIcon className="pe-2" icon={faDownload} />
                {downloading ? "downloading.." : "Download"}
              </Button>
            </>
          ) : (
            <></>
          )}
        </Modal.Footer> */}
      </Modal>
      <Row className="px-3">
        <Col>
          {noResults && (
            <Alert
              message="No results found"
              type="error"
              showIcon
              closable
              onClose={() => setNoResults(false)}
            />
          )}
          {/* --------------------------------------------------- FILTERS ---------------------------------------------- */}
          <Row className="my-4 align-items-center justify-content-center">
            <Col xs="auto" className="">
              <RangePicker
                className="py-2"
                value={dateRange}
                onChange={handleDateRangeChange}
                placeholder={["Start Date", "End Date"]}
              />
            </Col>
            <Col xs={4} className="my-auto">
              <Input
                className="py-2"
                placeholder="Unit Name"
                value={unitName}
                onChange={handleUnitNameFilter}
                allowClear
              />
            </Col>
            <Col xs="auto">
              <Button
                variant="outline-secondary"
                onClick={handleFilter}
                className="px-3 mx-1"
              >
                <FontAwesomeIcon icon={faMagnifyingGlass} />
              </Button>
              {hasPermission("toDownload") && (
                <Button
                  variant="outline-secondary"
                  onClick={handleDownloadExcel}
                  className="px-3 mx-1"
                >
                  <FontAwesomeIcon icon={faDownload} />
                </Button>
              )}
            </Col>
          </Row>
          {/* ------------------------------------------------ Table ---------------------------------------  */}
          <Row>
            <Col className="p-3 border border-1 rounded-4">
              <Row>
                <Col md={3} className="text-primary fw-semibold fs-5">
                  Unit name
                </Col>
                <Col md={3} className="text-primary fw-semibold fs-5">
                  Address
                </Col>
                <Col
                  md={2}
                  className="text-primary text-center fw-semibold fs-5"
                >
                  Earnings
                </Col>
                <Col
                  md={2}
                  className="text-primary text-center fw-semibold fs-5"
                >
                  Reviews
                </Col>
              </Row>
              <hr className="my-3" />

              {filterdLoading ? (
                <Loader />
              ) : filteredError ? (
                <Message>{"Message"}</Message>
              ) : (
                <>
                  {(filteredMaidListData.length > 0 &&
                  (unitName || (dateRange[0] && dateRange[1]))
                    ? filteredMaidListData
                    : maids
                  ).map((maid, index) => (
                    <Row className="align-items-center" key={index}>
                      <Col md={3} className="">
                        {maid.unitName}
                      </Col>
                      <Col md={3} className="text-muted fst-italic">
                        {maid.unitAddress}
                      </Col>
                      <Col md={2} className="text-center">
                        $
                        {maid.totalTipsInRange ||
                          calculateMaidStats(maid).totalEarnings}
                      </Col>
                      <Col md={2} className="text-center">
                        {maid.totalReviewsInRange ||
                          calculateMaidStats(maid).totalReviews}
                      </Col>
                      <Col md="auto" className="ms-auto me-5">
                        <Button
                          className="p-1 px-2 border-0"
                          variant="outline-success"
                          onClick={() => handleModal(maid)}
                        >
                          <FontAwesomeIcon
                            icon={faClipboard}
                            className="me-2"
                          />
                          View
                        </Button>
                      </Col>
                    </Row>
                  ))}
                </>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default AirbnbSumarized;
